import styled from 'styled-components';
import AllBookingActiveSvg from '../../assets/mytrips/all-bookings-active.svg';

const AllBookingActiveIcon = styled(AllBookingActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '3.2rem'};
  margin: ${props => props.margin};
`;

export default AllBookingActiveIcon;
